export const currenciesSelect = [
  { value: 1, label: "USD", icon: "us" },
  { value: 2, label: "RUB", icon: "ru" },
  { value: 3, label: "KZT", icon: "kz" },
  { value: 4, label: "KGS", icon: "kg" },
];

export const currencies = {
  1: "доллар (США)",
  2: "рубль",
  3: "тенге",
  4: "сом",
};

export const paymentMethods = {
  CASH: "Наличные",
  BANKING: "Безналичные",
  CARD: "На карту",
  COMBINED: "Комбинированная",
  ANY: "Любая",
};

export const paymentForms = {
  WHEN_LOADING: "По оригиналам документов",
  WHEN_UNLOADING: "Сразу на выгрузке",
  PREPAYMENT: "По копиям документов",
};

export const transformToSelect = (dict) => {
  return Object.keys(dict).map((key) => ({ value: key, label: dict[key] }));
};

export const orderTypes = {
  1: "Оборудование",
  2: "Стройматериалы",
  3: "Металл",
  4: "Продукты",
  5: "Запчасти",
  6: "Сырьё",
  7: "Мебель",
  8: "Металлопрокат",
  9: "Трубы",
};

export const addiotionLaods = {
  1: "Полная погрузка",
  2: "Догруз",
};

export const loadTypes = {
  1: "Верхняя загрузка",
  2: "Боковая загрузка",
  3: "Задняя загрузка",
  4: "С полной растентовкой",
};

export const packageTypes = [
  { value: 1, label: "EUR-палеты" },
  { value: 2, label: "FIN-палеты" },
  { value: 3, label: "Особые палеты" },
  { value: 4, label: "Коробки" },
  { value: 5, label: "Контейнер" },
  { value: 6, label: "Без упаковки" },
];
